module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"sitemove":"Sites Link","login":"로그인"},"en":{"sitemove":"Sites Link","login":"Login"},"ja":{"sitemove":"Sites Link","login":"ログイン"}}')
  delete Component.options._Ctor
}
